import Api from '@/api/Api'

export default {
  createOrder (params) {
    return Api().post('Order/createOrder', params)
  },
  fetchByParam (params) {
    return Api().post('Order/fetch_by_param', params)
  },
  fetchOrderList (params) {
    return Api().post('Order/fetch_order_list', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/OrderAPI.js